import { createAsyncThunk } from '@reduxjs/toolkit';
import { AICoachGoalsApi, GetAICoachGoalsResponse } from 'api/AICoachGoalsApi';

export const createGetAICoachGoalsThunk = (api: AICoachGoalsApi) =>
  createAsyncThunk('yourGoal/getAICoachGoals', async (applicationId: string, thunkApi) => {
    try {
      const goals: GetAICoachGoalsResponse = await api.getAICoachGoals(applicationId);
      return goals;
    } catch (error: any) {
      const payload = { ...(error.response?.data ?? {}), statusCode: error.responseStatus ?? 0 };
      return thunkApi.rejectWithValue(payload);
    }
  });
